export enum ImageSize {
  xs = 1,
  s,
  m,
  l,
}

export enum Colors {
  white = 1,
  grey,
  blue,
  emerald,
  green,
  yellow,
  orange,
}

export const imagesProps = [
  {
    size: ImageSize.s,
    color: Colors.blue,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.m,
    color: Colors.white,
    isLogo: true,
  },
  {
    size: ImageSize.m,
    color: Colors.yellow,
  },
  {
    size: ImageSize.s,
    color: Colors.emerald,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.s,
    color: Colors.green,
    isLogo: true,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.l,
    color: Colors.orange,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.m,
    color: Colors.grey,
    isLogo: true,
  },
  {
    size: ImageSize.s,
    color: Colors.yellow,
  },
  {
    size: ImageSize.s,
    color: Colors.blue,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.m,
    color: Colors.emerald,
    isLogo: true,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.s,
    color: Colors.orange,
    isLogo: true,
  },
  {
    size: ImageSize.m,
    color: Colors.green,
  },
  {
    size: ImageSize.l,
    color: Colors.yellow,
  },
  {
    size: ImageSize.s,
    color: Colors.white,
    isLogo: true,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.m,
    color: Colors.blue,
    isLogo: true,
  },
  {
    size: ImageSize.s,
    color: Colors.orange,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.m,
    color: Colors.yellow,
    isLogo: true,
  },
  {
    size: ImageSize.s,
    color: Colors.emerald,
  },
  {
    size: ImageSize.m,
    color: Colors.green,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.s,
    color: Colors.orange,
    isLogo: true,
  },
  {
    size: ImageSize.s,
    color: Colors.emerald,
    isLogo: true,
  },
  {
    size: ImageSize.l,
    color: Colors.blue,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.xs,
  },
  {
    size: ImageSize.s,
    color: Colors.yellow,
    isLogo: true,
  },
  {
    size: ImageSize.m,
    color: Colors.orange,
  },
];
